import React from 'react';
import loadable from '@loadable/component';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const SitecoreFormWrapper = (props) => {
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="SitecoreFormWrapper" />;
  const FormComponent = loadable(() => import('./SitecoreFormWrapper.js'), { ssr: false });
  return <FormComponent {...props} form={props?.fields} />;
};

export default SitecoreFormWrapper;
